import { useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import { getClienteByDni } from '../../../Services/clienteService'
import { getAllComprobantes } from '../../../Services/comprobanteService'
import { getByIdDepartamentos } from '../../../Services/departamentoService'
import { getAllListasPrecios } from '../../../Services/listaPrecioService'
import { savePresupuesto } from '../../../Services/presupuestoService'
import { getStockSucursalByCodigo } from '../../../Services/stockSucursalService'
import { getLastNroComprobante } from '../../../Services/ventaService'
import { determinarTipoComprobante } from '../Helpers'

const useVenta = (history) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    const fecha = new Date().toISOString().split('T')[0]

    const isMountedRef = useRef(true)
    const inputTotalRef = useRef(null)
    const [isLoad, setIsLoad] = useState(true)
    const [show, setShow] = useState(false)
    const [presupuestoId, setPresupuestoId] = useState(null)

    // datos de factura
    const [cliente, setCliente] = useState({ id: { persona: { dni: '' } } })
    const [numeroComprobante, setNumeroComprobante] = useState('')
    const [itemsFactura, setItemsFactura] = useState([])

    // Items y total
    const [codigoAndCantidad, setCodigoAndCantidad] = useState('')
    const [items, setItems] = useState([])
    const [total, setTotal] = useState(0)
    const [subtotal, setSubtotal] = useState(0)
    const [descuento, setDescuento] = useState(0)

    // consultar lista precio para dejar seteada la que se usara
    const [listasPrecios, setListasPrecios] = useState([])
    const [listaPrecio, setListaPrecio] = useState(1)

    // comprobante mas usado
    const [tiposComprobantes, setTiposComprobantes] = useState([])
    const [tipoComprobante, setTipoComprobante] = useState(3)

    // puntos obtenidos del cliente
    const [puntosArticulo, setPuntosArticulo] = useState(0)

    // estado para manejar el modal del login:
    const [showAdminModal, setShowAdminModal] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);

    // Custom swal
    const Toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 2000,
        onOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        },
    })

    useEffect(() => {
        if (isLoad) {
            const ptoVenta = sessionStorage.getItem('ptoventa')

            if (!ptoVenta) history.push('./apertura-caja')

            inputTotalRef.current.focus()

            // cargo el cliente por defecto
            getClienteByDni(9999999)
                .then(async (data) => {
                    if (isMountedRef.current) {
                        setCliente(data.data)
                        setListaPrecio(data.data.listaPrecio.id)
                        determinarTipoComprobante(
                            data.data.condicionFiscal.id,
                            setTipoComprobante
                        )
                    }
                })
                .catch((error) => {
                    if (isMountedRef.current) {
                        console.log(error.response)
                    }
                })

            // cargo listas de precios
            getAllListasPrecios(true, 0, '', 1000)
                .then((res) => {
                    if (isMountedRef.current) {
                        setListasPrecios(res.data.content)
                    }
                })
                .catch((error) => {
                    if (isMountedRef.current) {
                        console.log(error.response)
                    }
                })

            // cargo los comprobantes
            getAllComprobantes()
                .then((res) => {
                    if (isMountedRef.current) {
                        setTiposComprobantes(res.data)
                    }
                })
                .catch((error) => {
                    if (isMountedRef.current) {
                        console.log(error.response)
                    }
                })

            getLastNroComprobante()
                .then(async (res) => {
                    if (isMountedRef.current) {
                        setNumeroComprobante(res.data.id + 1)
                    }
                })
                .catch((error) => {
                    if (isMountedRef.current) {
                        console.log(error.response)
                    }
                })

            setIsLoad(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoad])

    useEffect(() => {
        return () => {
            isMountedRef.current = false
        }
    }, [])

    // Trabajar con centavos para evitar decimales
    const roundToCents = (value) => {
        return Math.round(value * 100) / 100
    }

    // Manejo de input cuando agregan articulos (estructura de 3 ramas)
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            const codigoString = String(codigoAndCantidad || '').trim()

            if (!codigoString) {
                Toast.fire({ title: 'Debe ingresar un código', type: 'info' })
                return
            }

            // 1. Venta por departamento
            if (codigoString.indexOf('-') !== -1) {
                procesarVentaPorDepartamento(codigoString)
                return
            }

            // 2. Venta por balanza
            if (codigoString.length >= 12 && codigoString.substring(0, 2) === '20') {
                procesarVentaPorBalanza(codigoString)
                return
            }

            // 3. Venta por código manual
            procesarVentaPorCodigoManual(codigoString)
        }
    }

    // ----------- 1. Venta por departamento -----------
    const procesarVentaPorDepartamento = (codigoAndCantidad) => {
        const inputFormateado = codigoAndCantidad.replace(',', '.')
        const valores = inputFormateado.split('-')

        if (valores.length !== 2) {
            Toast.fire({
                title: 'Formato inválido. Use: codigo-precio (ej: 1-15.50)',
                type: 'error',
            })
            setCodigoAndCantidad('')
            inputTotalRef.current.focus()
            return
        }

        const codigoDepartamento = parseInt(valores[0])
        if (isNaN(codigoDepartamento) || codigoDepartamento <= 0) {
            Toast.fire({
                title: 'Código de departamento inválido',
                type: 'error',
            })
            setCodigoAndCantidad('')
            inputTotalRef.current.focus()
            return
        }
        const precioDepartamento = parseFloat(valores[1])
        if (isNaN(precioDepartamento) || precioDepartamento <= 0) {
            Toast.fire({
                title: 'Precio inválido. Debe ser un número mayor a 0',
                type: 'error',
            })
            setCodigoAndCantidad('')
            inputTotalRef.current.focus()
            return
        }

        getByIdDepartamentos(codigoDepartamento).then((data) => {
            if (isMountedRef.current) {
                const departamento = data.data

                if (!departamento || !departamento.nombre) {
                    Toast.fire({
                        title: 'El departamento no existe',
                        type: 'info',
                    })
                    setCodigoAndCantidad('')
                    inputTotalRef.current.focus()
                    return
                }
                const precioRedondeado = roundToCents(precioDepartamento)
                const item = {
                    id: departamento.id,
                    codigo: departamento.id,
                    articulo: departamento.nombre,
                    cantidad: 1,
                    precio: precioRedondeado,
                    iva: departamento.tasaIva,
                    descuento: 0,
                    pesable: false,
                    tipo: 'departamento',
                    total: precioRedondeado
                }

                const itemFactura = {
                    departamento: departamento,
                    cantidad: 1,
                    descuento: 0,
                    precio: precioRedondeado,
                }

                setItemsFactura((prev) => [...prev, itemFactura])
                setItems((prev) => [...prev, item])
                setTotal((prev) => roundToCents(prev + precioRedondeado))
                setSubtotal((prev) => roundToCents(prev + precioRedondeado))

                setCodigoAndCantidad('')
                inputTotalRef.current.focus()
            }
        }).catch((error) => {
            if (isMountedRef.current) {
                Toast.fire({
                    title: 'El departamento no existe o hubo un error',
                    type: 'error',
                });
                setCodigoAndCantidad('');
                inputTotalRef.current.focus();
            }
        })
    }

    // ----------- 2. Venta por balanza -----------
    const procesarVentaPorBalanza = (codigoString) => {
        const precioArticuloBalanza = parseFloat(codigoString.slice(5, 12)) / 100;
        const codigoArticulo = codigoString.slice(2, 5); // 3 dígitos para el código del artículo

        getStockSucursalByCodigo(token.sucursal.id, codigoArticulo, listaPrecio)
            .then((data) => {
                if (!isMountedRef.current) return
                const stockSucursal = data.data
                const articulo = stockSucursal.articulo

                // Valido si el artículo existe
                if (!articulo) {
                    Toast.fire({
                        title: 'El artículo no existe',
                        type: 'info',
                    });
                    setCodigoAndCantidad('');
                    inputTotalRef.current.focus();
                    return;
                }

                if (articulo.pesable) {
                    const precioKilo = parseFloat(articulo.precioFinal !== 0 ? articulo.precioFinal : (stockSucursal.precioFinal !== 0 ? stockSucursal.precioFinal : articulo.precioFinalCalculado));
                    const gramosLLeva = roundToCents((precioArticuloBalanza * 1000.0) / precioKilo); // Se redondean los gramos también

                    if (gramosLLeva > parseFloat(stockSucursal.cantidad)) { // Comparar con stockSucursal.cantidad
                        Toast.fire({
                            title: `Advertencia. Falta de stock`,
                            type: 'warning',
                        })
                        setCodigoAndCantidad('')
                        inputTotalRef.current.focus()
                    }

                    const item = {
                        id: articulo.codigo,
                        codigo: articulo.codigo,
                        articulo: `${articulo.nombre} (${Math.trunc(gramosLLeva)} gr)`,
                        cantidad: 1,
                        precio: roundToCents(precioArticuloBalanza),
                        iva: articulo.familia.departamento.tasaIva,
                        descuento: 0,
                        pesable: true,
                        tipo: 'articulo',
                        total: roundToCents(precioArticuloBalanza * 1.0)
                    }

                    const itemFactura = {
                        articulo: articulo,
                        cantidad: gramosLLeva,
                        descuento: 0,
                        precio: roundToCents(precioArticuloBalanza),
                    }

                    setItemsFactura((prev) => [...prev, itemFactura])
                    setItems((prev) => [...prev, item])
                    setTotal((prev) => roundToCents(prev + precioArticuloBalanza)) // Sumar el precio total pagado
                    setSubtotal((prev) => roundToCents(prev + precioArticuloBalanza))

                } else { // Artículo No Pesable
                    const precioUnidad = stockSucursal.precioFinal !== 0 ? stockSucursal.precioFinal : (articulo.precioFinal !== 0 ? articulo.precioFinal : articulo.precioFinalCalculado);
                    const cantidadUnidades = Math.round(precioArticuloBalanza / precioUnidad);

                    if (cantidadUnidades > parseFloat(stockSucursal.cantidad)) { // Comparar con stockSucursal.cantidad
                        Toast.fire({
                            title: `Advertencia. Falta de stock.`,
                            type: 'warning',
                        })
                        setCodigoAndCantidad('')
                        inputTotalRef.current.focus()
                    }

                    const item = {
                        id: articulo.codigo,
                        codigo: articulo.codigo,
                        articulo: `${articulo.nombre} (${cantidadUnidades} unidad/es)`,
                        cantidad: cantidadUnidades,
                        precio: roundToCents(precioUnidad),
                        iva: articulo.familia.departamento.tasaIva,
                        descuento: 0,
                        pesable: false,
                        tipo: 'articulo',
                        total: roundToCents(precioUnidad * cantidadUnidades),
                    }

                    const itemFactura = {
                        articulo: articulo,
                        cantidad: cantidadUnidades,
                        descuento: 0,
                        precio: roundToCents(precioUnidad),
                    }

                    setItemsFactura((prev) => [...prev, itemFactura])
                    setItems((prev) => [...prev, item])
                    setTotal((prev) => roundToCents(prev + precioArticuloBalanza))
                    setSubtotal((prev) => roundToCents(prev + precioArticuloBalanza))
                }

                setCodigoAndCantidad('')
                inputTotalRef.current.focus()
            })
            .catch((error) => handleErrorBusquedaArticulo(error))
    }

    // ----------- 3. Venta por código manual -----------
    const procesarVentaPorCodigoManual = (codigoString) => {
        let cantidad = 1
        let codigoArticulo = codigoString

        if (codigoString.indexOf('*') !== -1) {
            const valores = codigoString.split('*')
            cantidad = parseFloat(valores[0])
            codigoArticulo = valores[1]
        }

        getStockSucursalByCodigo(token.sucursal.id, codigoArticulo, listaPrecio)
            .then((data) => {
                if (!isMountedRef.current) return
                const stockSucursal = data.data
                const articulo = stockSucursal.articulo

                if (!articulo) {
                    Toast.fire({
                        title: 'El artículo no existe',
                        type: 'info',
                    });
                    setCodigoAndCantidad('');
                    inputTotalRef.current.focus();
                    return;
                }

                if (articulo.pesable) {
                    const gramos = cantidad === 1 ? 1000 : cantidad // Si no hay cantidad, asumo 1kg (1000gr)
                    const precioKilo = parseFloat(articulo.precioFinal !== 0 ? articulo.precioFinal : (stockSucursal.precioFinal !== 0 ? stockSucursal.precioFinal : articulo.precioFinalCalculado));
                    const precioCantidad = roundToCents((precioKilo / 1000.0) * gramos)

                    if (gramos > parseFloat(stockSucursal.cantidad)) {
                        Toast.fire({
                            title: `Advertencia. Falta de stock`,
                            type: 'warning',
                        })
                        setCodigoAndCantidad('')
                        inputTotalRef.current.focus()
                    }

                    const item = {
                        id: articulo.codigo,
                        codigo: articulo.codigo,
                        articulo: `${articulo.nombre} (${Math.trunc(gramos)} gr)`,
                        cantidad: 1,
                        precio: precioCantidad,
                        iva: articulo.familia.departamento.tasaIva,
                        descuento: 0,
                        pesable: true,
                        tipo: 'articulo',
                        total: precioCantidad * 1.0
                    }

                    const itemFactura = {
                        articulo: articulo,
                        cantidad: gramos,
                        descuento: 0,
                        precio: precioCantidad,
                    }

                    setItemsFactura((prev) => [...prev, itemFactura])
                    setItems((prev) => [...prev, item])
                    setTotal((prev) => roundToCents(prev + precioCantidad))
                    setSubtotal((prev) => roundToCents(prev + precioCantidad))

                } else { // Artículo No Pesable (En la app desktop si se consolidan los items)
                    if (cantidad > parseFloat(stockSucursal.cantidad)) {
                        Toast.fire({
                            title: `Advertencia. Falta de stock.`,
                            type: 'warning',
                        })
                        setCodigoAndCantidad('')
                        inputTotalRef.current.focus()
                    }

                    const precioUnidad = stockSucursal.precioFinal !== 0 ? stockSucursal.precioFinal : (articulo.precioFinal !== 0 ? articulo.precioFinal : articulo.precioFinalCalculado);
                    const precioTotalItem = roundToCents(precioUnidad * cantidad)

                    // Si artículo ya existe, sumo cantidad (la lógica C# lo hace)
                    const existingItemIndex = items.findIndex(
                        (item) => item.tipo === 'articulo' && !item.pesable && item.id === articulo.codigo
                    );

                    if (existingItemIndex !== -1) {
                        const updatedItems = [...items];
                        const updatedItemsFactura = [...itemsFactura];

                        // Actualizar cantidad y total en UI
                        updatedItems[existingItemIndex].cantidad = roundToCents(updatedItems[existingItemIndex].cantidad + cantidad);
                        updatedItems[existingItemIndex].total = roundToCents(updatedItems[existingItemIndex].cantidad * updatedItems[existingItemIndex].precio); // Total = Cantidad acumulada * Precio unitario

                        // Actualizar cantidad en factura
                        updatedItemsFactura[existingItemIndex].cantidad = roundToCents(updatedItemsFactura[existingItemIndex].cantidad + cantidad);
                        // El precio en factura para no pesables sigue siendo el precio unitario del artículo
                        updatedItemsFactura[existingItemIndex].precio = roundToCents(precioUnidad);

                        setItems(updatedItems);
                        setItemsFactura(updatedItemsFactura);
                        setTotal((prev) => roundToCents(prev + precioTotalItem)); // Sumar el total de la nueva cantidad agregada
                        setSubtotal((prev) => roundToCents(prev + precioTotalItem));

                        setCodigoAndCantidad('');
                        inputTotalRef.current.focus();
                        return;
                    }

                    // Si no existe, agregar normalmente
                    const item = {
                        id: articulo.codigo, // Usar codigo para el ID en UI
                        codigo: articulo.codigo,
                        articulo: articulo.nombre,
                        cantidad: cantidad,
                        precio: roundToCents(precioUnidad),
                        iva: articulo.familia.departamento.tasaIva,
                        descuento: 0,
                        pesable: false,
                        tipo: 'articulo',
                        total: precioTotalItem,
                    }

                    const itemFactura = {
                        articulo: articulo,
                        cantidad: cantidad,
                        descuento: 0,
                        precio: roundToCents(precioUnidad),
                    }

                    setItemsFactura((prev) => [...prev, itemFactura])
                    setItems((prev) => [...prev, item])
                    setTotal((prev) => roundToCents(prev + precioTotalItem))
                    setSubtotal((prev) => roundToCents(prev + precioTotalItem))
                }
                setCodigoAndCantidad('')
                inputTotalRef.current.focus()
            })
            .catch((error) => handleErrorBusquedaArticulo(error))
    }

    // Manejo de errores al buscar artículo
    const handleErrorBusquedaArticulo = (error) => {
        if (isMountedRef.current) {
            Toast.fire({
                title: 'El articulo no existe',
                type: 'info',
            })
            setCodigoAndCantidad('')
            inputTotalRef.current.focus()
        }
    }

    // Elimina items de la lista de articulos
    const deleteItem = (articulo, key) => {
        if (!token.authorities.includes('ROLE_ADMIN')) {
            setPendingAction(() => () => _deleteItem(articulo, key));
            setShowAdminModal(true);
            return;
        }
        _deleteItem(articulo, key);
    }

    const _deleteItem = (articulo, key) => {
        // Filtra los items para eliminar el correcto
        const updatedItems = items.filter((item, index) => {
            // Un item es único por su ID y su índice en la lista (para manejar duplicados no consolidados)
            return item.id !== articulo.id || index !== key;
        });

        // Filtra los items de factura de forma similar
        const updatedItemsFactura = itemsFactura.filter((itemFactura, index) => {
            // Departamentos se identifican por departamento.id, artículos por articulo.id
            const itemIdInFactura = itemFactura.departamento ? itemFactura.departamento.id : (itemFactura.articulo ? itemFactura.articulo.codigo : null);
            const articuloIdInFactura = articulo.id; // Asumo que `articulo.id` contiene el ID/Código correcto para comparar

            return itemIdInFactura !== articuloIdInFactura || index !== key;
        });

        setItemsFactura(updatedItemsFactura);
        setItems(updatedItems);

        // Recalcular totales
        let montoARestar = 0;
        if (articulo.tipo === 'departamento') {
            montoARestar = articulo.precio; // Para departamentos, se resta el precio directo
        } else if (articulo.pesable) {
            montoARestar = articulo.precio; // Para pesables de balanza/manual, se resta el precio total del item en UI
        } else {
            montoARestar = articulo.precio * articulo.cantidad; // Para no pesables, se resta precio unitario * cantidad
        }

        setTotal(roundToCents(total - montoARestar));
        setSubtotal(roundToCents(subtotal - montoARestar));

        // Solo se resta puntos si no es un departamento y es un artículo
        if (articulo.tipo === 'articulo') {
            if (articulo.pesable) {
                const itemFacturaOriginal = itemsFactura.find((item, index) => {
                    const itemIdInFactura = item.departamento ? item.departamento.id : (item.articulo ? item.articulo.codigo : null);
                    return itemIdInFactura === articulo.id && index === key && item.articulo && item.articulo.pesable;
                });
                if (itemFacturaOriginal && itemFacturaOriginal.articulo) {
                    setPuntosArticulo(puntosArticulo - (itemFacturaOriginal.articulo.puntos * (itemFacturaOriginal.cantidad / 1000))); // Puntos por gramo/kilo
                }
            } else {
                if (articulo.puntos) {
                    setPuntosArticulo(roundToCents(puntosArticulo - (articulo.puntos * articulo.cantidad)));
                }
            }
        }

        inputTotalRef.current.focus()
    }

    //Para crear un presupuesto
    const createPresupuesto = () => {
        if (cliente.id.persona.dni.length <= 0 || itemsFactura.length === 0) {
            Swal.fire({
                title: 'No se puede generar un presupuesto vacio.',
                type: 'info',
                showConfirmButton: false,
                timer: 1500,
            })
            return
        }

        let today = new Date()

        let presupuesto = {
            total: parseFloat(total).toFixed(2),
            tipoComprobanteId: tipoComprobante,
            clienteId: cliente.id.persona.id,
            items: itemsFactura,
            sucursalId: token.sucursal.id,
            fechaVencimiento: new Date(today.getTime()).setDate(today.getDate() + 14),
        }

        savePresupuesto(presupuesto)
            .then((data) => {
                if (isMountedRef.current) {
                    Swal.fire({
                        position: 'top',
                        toast: true,
                        title: 'Presupuesto creado.',
                        type: 'success',
                        showConfirmButton: false,
                        timer: 1500,
                    })
                }
            })
            .catch((err) => {
                if (isMountedRef.current) {
                    Swal.fire({
                        title: 'Faltan datos, no se pudo crear el presupuesto',
                        type: 'error',
                        showConfirmButton: false,
                        timer: 1500,
                    })
                }
            })
    }

    const handleShow = () => {
        setShow(true)
    }

    const handleClose = () => {
        setShow(false)
    }

    const reset = (skipAdminCheck = false) => {
        if (!skipAdminCheck && !token.authorities.includes('ROLE_ADMIN')) {
            setPendingAction(() => _reset);
            setShowAdminModal(true);
            return;
        }
        _reset();
    }

    const _reset = () => {
        setItems([])
        setItemsFactura([])
        setTotal(0)
        setSubtotal(0)
        setDescuento(0)
        setPuntosArticulo(0)
        getClienteByDni(9999999)
            .then(async (data) => {
                if (isMountedRef.current) {
                    setCliente(data.data)
                    setListaPrecio(data.data.listaPrecio.id)
                    determinarTipoComprobante(
                        data.data.condicionFiscal.id,
                        setTipoComprobante
                    )
                }
            })
            .catch((error) => {
                if (isMountedRef.current) {
                    console.log(error.response)
                }
            })
        getLastNroComprobante()
            .then(async (res) => {
                if (isMountedRef.current) {
                    setNumeroComprobante(res.data.id + 1)
                }
            })
            .catch((error) => {
                if (isMountedRef.current) {
                    console.log(error.response)
                }
            })
    }

    // Función para reset completo (cuando se cancela venta o se finaliza)
    const resetCompleto = () => {
        reset()
        setPresupuestoId(null)
    }

    const agregarItemManualmente = (articuloVenta) => {
        const articuloFormateado = {
            id: articuloVenta.articulo.codigo,
            codigo: articuloVenta.articulo.codigo,
            articulo: articuloVenta.articulo.nombre,
            cantidad: articuloVenta.cantidad,
            precio: articuloVenta.precio,
            iva: articuloVenta.articulo.porcentajeIva || 21,
            descuento: articuloVenta.descuento || 0,
            pesable: articuloVenta.articulo.pesable || false,
            tipo: 'articulo',
            total: articuloVenta.total || (articuloVenta.cantidad * articuloVenta.precio),
            fromPresupuesto: articuloVenta.fromPresupuesto || false
        };

        const itemFactura = {
            articulo: articuloVenta.articulo,
            cantidad: articuloVenta.cantidad,
            descuento: articuloVenta.descuento || 0,
            precio: articuloVenta.precio,
        };


        setItems(prevItems => [...prevItems, articuloFormateado]);
        setItemsFactura(prevItems => [...prevItems, itemFactura]);

        const totalItem = articuloFormateado.total;
        setTotal(prev => roundToCents(prev + totalItem));
        setSubtotal(prev => roundToCents(prev + totalItem));

        if (articuloVenta.articulo.puntos) {
            if (articuloVenta.articulo.pesable) {
                setPuntosArticulo(prev => roundToCents(prev + (articuloVenta.articulo.puntos * (articuloVenta.cantidad / 1000))));
            } else {
                setPuntosArticulo(prev => roundToCents(prev + (articuloVenta.articulo.puntos * articuloVenta.cantidad)));
            }
        }
    };

    return {
        total,
        cliente,
        setListaPrecio,
        setTipoComprobante,
        setCliente,
        tipoComprobante,
        numeroComprobante,
        fecha,
        items,
        listasPrecios,
        tiposComprobantes,
        itemsFactura,
        subtotal,
        descuento,
        isLoad,
        show,
        handleShow,
        handleClose,
        setCodigoAndCantidad,
        codigoAndCantidad,
        inputTotalRef,
        deleteItem,
        reset,
        resetCompleto,
        createPresupuesto,
        handleKeyPress,
        listaPrecio,
        puntosArticulo,
        agregarItemManualmente,
        presupuestoId,
        setPresupuestoId,
        showAdminModal,
        setShowAdminModal,
        pendingAction,
        setPendingAction,
    }
}


export default useVenta